import React from "react";

const ArrayFieldSection = ({ field, formData, setFormData, dropdownData }) => {
  const fieldName = field.fields;
  const prefilledField = field.subfields.find((sf) => sf.Prefilled);
  const prefilledValues = prefilledField?.Prefilled || [];

  const arrayToRender = prefilledValues.length
    ? prefilledValues.map((value, index) => ({
        [prefilledField.fields]: value,
        ...(formData[fieldName]?.[index] || {}),
      }))
    : formData[fieldName] || [];

  const handleArrayChange = (index, subField, value) => {
    const updatedArray = [...arrayToRender];
    updatedArray[index] = { ...updatedArray[index], [subField]: value };
    setFormData((prev) => ({ ...prev, [fieldName]: updatedArray }));
  };

  const handleAdd = () => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: [...(prev[fieldName] || []), {}],
    }));
  };

  const handleRemove = (index) => {
    const updatedArray = [...formData[fieldName]];
    updatedArray.splice(index, 1);
    setFormData((prev) => ({ ...prev, [fieldName]: updatedArray }));
  };

  return (
    <div className="subfields-wrapper">
      {arrayToRender.map((item, itemIndex) => (
        <div key={itemIndex} className="array-group">
          {field.subfields.map((subField, subIndex) => (
            <div key={subIndex} className="form-group subfield-group">
              <label className="form-label">{subField.fields}</label>
              {subField.Prefilled ? (
                <input
                  className="form-input"
                  value={item[subField.fields]}
                  readOnly
                />
              ) : subField.options ? (
                <select
                  className="form-select"
                  value={item[subField.fields] || ""}
                  onChange={(e) =>
                    handleArrayChange(
                      itemIndex,
                      subField.fields,
                      e.target.value
                    )
                  }
                >
                  <option value="">Select {subField.fields}</option>
                  {subField.options.map((opt, i) => (
                    <option key={i} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  className="form-input"
                  value={item[subField.fields] || ""}
                  onChange={(e) =>
                    handleArrayChange(
                      itemIndex,
                      subField.fields,
                      e.target.value
                    )
                  }
                />
              )}
            </div>
          ))}
          {!prefilledField && (
            <button
              type="button"
              onClick={() => handleRemove(itemIndex)}
              className="remove-btn"
            >
              Remove
            </button>
          )}
        </div>
      ))}
      {!prefilledField && (
        <button type="button" onClick={handleAdd} className="add-btn">
          Add {field.fields}
        </button>
      )}
    </div>
  );
};

export default ArrayFieldSection;
